export default __webpack_public_path__ + "static/media/mtpit-macapp-icon.b0bb4aa9.png";